












import Vue from 'vue'
import * as R from 'ramda'
import { Component, Prop } from 'vue-property-decorator'
import AppTextField from '@/components/AppTextField.vue'
import AppDatePicker from '@/components/AppDatePicker.vue'
import AppSelector from '@/components/AppSelector.vue'
import { IAccountCertificateDDCInput } from '@/modules/AccountCertificate/interfaces/account-certificate-form'

@Component({
  components: {
    AppTextField,
    AppSelector,
    AppDatePicker
  }
})
export default class AccountCertificateFormDDC extends Vue {
  @Prop({ type: Object as () => IAccountCertificateDDCInput }) value!: IAccountCertificateDDCInput

  R = R

  get today () {
    return this.$moment().format('YYYY-MM-DD')
  }

  validate () {
    return true
  }
}
